import { a as o_global } from "../chunks/common-namespaces-client-C7k75bsz.mjs";
import { o as otto } from "../chunks/common-nexus-client-MnzJr7CK.mjs";
const device = o_global.device ?? {};
const browser = device.browser;
const hybrid = device.hybrid;
const isTouchable = device.isTouchable;
const orientation = device.orientation;
const os = device.os;
const screen = device.screen;
const type = device.type;
const getPointerType = (otto.device ?? {}).getPointerType;
export {
  browser,
  device,
  getPointerType,
  hybrid,
  isTouchable,
  orientation,
  os,
  screen,
  type
};
/*                                      */
